"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import newsclipLogo from "@/img/newsclip.png";

const navigation: { label: string; href: string; active?: boolean; newTab?: boolean }[] = [
  { label: "Home", href: "/" },
  { label: "Solutions", href: "/solutions" },
  { label: "About", href: "/about" },
  { label: "Blog", href: "/news" },
  { label: "Contact Us", href: "/#contact" },
  { label: "POPI - PAIA", href: "/docs/paia-manual-newsclip.pdf", newTab: true }
];

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  function closeMenu() {
    setIsOpen(false);
  }

  return (
    <header className="site-header">
      <nav className="container nav" aria-label="Main navigation">
        <Link className="brand" href="/" aria-label="Newsclip home">
          <Image src={newsclipLogo} alt="Newsclip" width={117} height={39} priority />
        </Link>
        <button
          className="nav-toggle"
          type="button"
          aria-controls="primary-navigation"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className={`nav-menu${isOpen ? " open" : ""}`} id="primary-navigation">
          <div className="nav-links">
            {navigation.map((item) =>
              item.newTab ? (
                <a
                  className={`nav-link${item.active ? " active" : ""}`}
                  href={item.href}
                  key={item.label}
                  rel="noreferrer"
                  target="_blank"
                  onClick={closeMenu}
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  className={`nav-link${item.active ? " active" : ""}`}
                  href={item.href}
                  key={item.label}
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              )
            )}
          </div>
          <div className="nav-actions">
            <a className="gate-link" href="https://www.gate5.co.za" onClick={closeMenu}>
              LOGIN TO GATE 5
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
